import slugify from 'slugify';

export function buildEventSlug(
  id: number,
  event: { name?: string; nameEng?: string; nameIta?: string; nameSlo?: string; nameSr?: string; nameBs?: string }
): string {
  const name = event.name ?? event.nameEng ?? event.nameIta ?? event.nameSlo ?? event.nameSr ?? event.nameBs ?? '';
  const slugPart = slugify(name, { lower: true, strict: true });
  return slugPart ? `${id}-${slugPart}` : String(id);
}

export function buildLeagueSlug(
  id: number,
  league: { name?: string; nameEng?: string; nameIta?: string; nameSlo?: string; nameSr?: string; nameBs?: string }
): string {
  const name = league.name ?? league.nameEng ?? league.nameIta ?? league.nameSlo ?? league.nameSr ?? league.nameBs ?? '';
  const slugPart = slugify(name, { lower: true, strict: true });
  return slugPart ? `${id}-${slugPart}` : String(id);
}

export function extractIdFromSlug(slug: string): number | null {
  const match = slug.match(/^(\d+)/);
  if (!match) return null;
  const id = parseInt(match[1], 10);
  return isNaN(id) ? null : id;
}
